var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyIconTeamLeadManager({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.375H3.75a3.507 3.507 0 0 0-3.5 3.5c0 .492.383.875.875.875h7A.881.881 0 0 0 9 13.875c0-1.914-1.586-3.5-3.5-3.5zm-3.91 3.063c.219-.985 1.094-1.75 2.16-1.75H5.5c1.04 0 1.914.765 2.133 1.75H1.59zM4.625 9.5A2.608 2.608 0 0 0 7.25 6.875 2.626 2.626 0 0 0 4.625 4.25 2.608 2.608 0 0 0 2 6.875 2.608 2.608 0 0 0 4.625 9.5zm0-3.938c.71 0 1.313.602 1.313 1.313 0 .738-.602 1.313-1.313 1.313a1.296 1.296 0 0 1-1.313-1.313c0-.71.575-1.313 1.313-1.313zM16.219.75H6.156c-.847 0-1.531.71-1.531 1.531v.656c0 .383.273.657.656.657a.648.648 0 0 0 .657-.656V2.28c0-.11.082-.219.218-.219H16.22c.11 0 .218.11.218.22v8.312c0 .136-.109.219-.218.219h-1.532v-.876a.9.9 0 0 0-.874-.874h-2.188a.881.881 0 0 0-.875.874v.876h-.875c-.383 0-.656.3-.656.656 0 .383.273.656.656.656h6.344c.82 0 1.531-.684 1.531-1.531V2.28c0-.82-.71-1.531-1.531-1.531z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIconTeamLeadManager);
export default __webpack_public_path__ + "static/media/survey-icon-team-lead-manager.e8c0178583c618eb1e96e021162dc7f4.svg";
export { ForwardRef as ReactComponent };